onComplete(function () {
	const isMobile = window.matchMedia("(max-width: 991px)").matches;
	const PAGE_SCROLL_THRESHOLD = isMobile ? 150 : 300;

	window.addEventListener('scroll', () => {
		const scroll = window.pageYOffset || document.documentElement.scrollTop;
		const navHeader = document.querySelectorAll('.nav-header');
		if (scroll >= PAGE_SCROLL_THRESHOLD) {
			navHeader.forEach(el => el.classList.add('scroll'));
		} else {
			navHeader.forEach(el => el.classList.remove('scroll'));
		}
	})
	document.querySelectorAll('h1, h2, h3').forEach(el => {
		const html = el.innerHTML.trim();
		const match = html.match(/^(\s*<[^>]+>)*([^<>\s]+)([\s\S]*)$/);

		if (match) {
			const before = match[1] || '';
			const firstWord = match[2];
			const rest = match[3] || '';
			el.innerHTML = `${before}<span>${firstWord}</span>${rest}`;
		}
	});
});